import React, {Component} from 'react';
import './swipe.css'
import { catalog } from '../../lib/utils'
import Carousel, { Dots } from '@brainhubeu/react-carousel';
import './slider.css';
import { products } from "../../const/projects";
import { withUiContext } from "../../UiContext";

class Swipe extends Component {

    state = {
        value: 0,
        catalog: catalog(products, this.props.section)
    }

    change = val => this.setState({value: val});

    playOverSound = () => {
        const {ui} = this.props
        ui.playOverSound()
    }

    playClickSound = () => {
        const {ui} = this.props
        ui.playClickSound()
    }

    handleMouseEnter = () => {
        this.playOverSound()
    }

    handleClick = (key) => {
        this.playClickSound()

        this.props.click(key)
    }

    render() {
        return (
            <div className="swipe" onMouseOver={e => {e.preventDefault()}}>
                <div className="carousel-wrap">
                    <Carousel arrows
                        value={this.state.value} number={this.state.catalog.length}
                        onChange={this.change}
                    >
                        {this.state.catalog.map((row, i) => (
                            <div key={i} className="swipe-wrap">
                                {row.map((key, index) => (
                                    <div key={index}
                                         className="swipe-item"
                                         onMouseEnter={this.handleMouseEnter}
                                         onClick={() => this.handleClick(key)}
                                    >
                                        <img src={require('../../assets/img/catalog/'+key.photo+'.png')} alt={key.title} />
                                        <h2 style={{textAlign: 'center'}}>{key.name}</h2>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </Carousel>
                    <div className="pagination">
                        <img alt="Предыдущая" style={{marginRight: '35px', display: this.state.value === 0 ? 'none' : 'inline'}}
                            onClick={() => this.setState({value: this.state.value-1})}
                            src={require('../../assets/img/arrow1.png')}
                        />
                        <Dots value={this.state.value} number={this.state.catalog.length}
                            onChange={this.change}
                            thumbnails= {this.state.catalog.map((key, index) =>
                                <div key={index}
                                    className="pagin-page"
                                >
                                {index+1}
                                </div>
                            )}
                        />
                        <img alt="Следующая" style={{transform: 'rotate(180deg)', display: this.state.value === (this.state.catalog.length-1) ? 'none' : 'inline'}}
                            onClick={() => this.setState({value: this.state.value+1})}
                            src={require('../../assets/img/arrow1.png')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withUiContext(Swipe)
